import { getDicts } from "@/utils/api"

// 字典缓存：dictType -> Promise，同一字典整个应用只请求一次
const dictCache = {}

/**
 * 批量加载字典数据（带缓存，请求失败允许下次重试）
 * @param {Array} dictTypes 字典类型数组，如 ['sys_normal_disable', 'park_pay_status']
 * @returns {Promise<{ [dictType]: Array }>}
 */
export function loadDicts(dictTypes) {
    const types = [...new Set(dictTypes)]
    const results = {}
    return Promise.all(
        types.map(type => {
            if (!dictCache[type]) {
                dictCache[type] = getDicts(type)
                    .then(res => res.data || [])
                    .catch(() => {
                        delete dictCache[type]
                        return []
                    })
            }
            return dictCache[type].then(list => {
                results[type] = list
            })
        })
    ).then(() => results)
}

/**
 * 从字典列表中取标签
 * @param {Array} dictList 字典列表 this.dict.type.xxx
 * @param {String|Number} value 字典值
 * @returns {String} 匹配不到时原样返回 value
 */
export function dictLabel(dictList, value) {
    const item = (dictList || []).find(d => String(d.dictValue) === String(value))
    return item ? item.dictLabel : value
}

export default {
    install(Vue) {
        /**
         * 用法：组件中声明 dicts 选项，模板/脚本里通过 this.dict.type.字典类型 取列表
         *
         * export default {
         *     dicts: ['park_pay_status'],
         *     ...
         * }
         * 列表项字段：dictLabel（标签）、dictValue（值）、listClass（标签颜色样式）、cssClass（自定义样式）
         */
        Vue.mixin({
            data() {
                if (!this.$options.dicts) {
                    return {}
                }
                const type = {}
                this.$options.dicts.forEach(t => {
                    type[t] = []
                })
                return {
                    dict: { type }
                }
            },
            created() {
                if (!this.$options.dicts) {
                    return
                }
                loadDicts(this.$options.dicts).then(results => {
                    Object.keys(results).forEach(t => {
                        this.dict.type[t] = results[t]
                    })
                })
            }
        })

        // 值转标签，仅对声明了 dicts 的组件可用：this.$dictLabel('park_pay_status', 1)
        Vue.prototype.$dictLabel = function(dictType, value) {
            return dictLabel(this.dict && this.dict.type[dictType], value)
        }
    }
}
